//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {
    
    //Use strict mode
    'use strict';

    /**
     * @class am.BaseLayerSelectorController
     * @fires BaseLayerSelectorController
     *
     * This class implements the controller of the base layer selector.
     */
    module.BaseLayerSelectorController = function() {
        // Private attributes
        this._map  = undefined;          // reference to the map
        this._controlButton = undefined; // reference to the button allowing the user to choose the base layer
        this._baseLayers = {};           // instances of L.Layer corresponding to the available base layers
        this._config = {
            position: 'topleft', // position of the widget relative to the map container
            satelliteLayerName: "BingAerial",
            satelliteLayerKey:  "AmIJiNgag0Ptbj3NP93R91ICItjHCx39jtMJiW6tjND_hoF_Dc1x5QilQIarhppr",
            satelliteLayerYear: "",
            mapLayerName: "OpenStreetMaps",
            mapLayerKey:  "",
            mapLayerYear: "",
            initialBaseLayer: 'satellite'
        };
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Object specifying the configuration to be applied to the controller. The same arguments
     *		which can be passed to the constructor of class L.Control can also be specified here
     *      (see http://leafletjs.com/reference-1.2.0.html#control). In addition, this object may contain the following
     *		keys:
     *			- "layers": Array specifying the base layers to be proposed to the user in the drop-down menu.
     *				Each element of this array should be an object with the following two keys:
     *					- "name": Name of the layer (e.g. 'IgnAerial', 'OpenStreetMaps', 'BingAerial', etc.)
     *					- "apiKey": [optional] API key to access the layer tiles
     *			  By default, the IGN aerial maps and the Open Street maps are proposed to the user
     */
    module.BaseLayerSelectorController.prototype.init = function(mainController, config) {
        var _this = this;

        // Merge the config specified by the user with the default config
        this._config = am.utils.mergeObjects(this._config, config);

        // Instantiate the private attributes
        var showSatelliteBaseLayer = this._config.initialBaseLayer == 'satellite';
        this._map = mainController.getMapObject();
        this._baseLayers.satellite = this._instantiateBaseLayer(this._config.satelliteLayerName,
            this._config.satelliteLayerKey, this._config.satelliteLayerYear);
        this._baseLayers.map = this._instantiateBaseLayer(this._config.mapLayerName, this._config.mapLayerKey,
            this._config.mapLayerYear);
        this._controlButton = am.utils.twoStateButton({
            cssClass: "am-base-layer-selector-button am-widget-frame",
            activeStateCallback: function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this._map.setBaseLayer(_this._baseLayers.map);
            },
            inactiveStateCallback: function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this._map.setBaseLayer(_this._baseLayers.satellite);
            },
            position: 'bottomleft',
            activeStateContentsClass: 'am-show-map-baselayer',
            inactiveStateContentsClass: 'am-show-satellite-baselayer',
            activeStateContentsText: am.translator.translate('map'),
            inactiveStateContentsText: am.translator.translate('satellite'),
            activeStateTooltip: am.translator.translate('showMapBaseLayer'),
            inactiveStateTooltip: am.translator.translate('showSatelliteBaseLayer'),
            active: showSatelliteBaseLayer
        });

        // Set the current base layer
        this._map.setBaseLayer(showSatelliteBaseLayer ? this._baseLayers.satellite : this._baseLayers.map);

        am.eventManager.register('hide_base_layer_selector', this.hideBaseLayerField, this);
        am.eventManager.register('show_base_layer_selector', this.showBaseLayerField, this);

        // Add the button to the map
        this._controlButton.addTo(this._map);
        $(this._controlButton.getContainer()).addClass('am-base-layer-selector');
    };

    /**
     * Class destructor
     */
    module.BaseLayerSelectorController.prototype.destroy = function() {
        // Remove control button from the map and remove references to external objects

        am.eventManager.unregister('hide_base_layer_selector', this.hideBaseLayerField, this);
        am.eventManager.unregister('show_base_layer_selector', this.showBaseLayerField, this);

        this._controlButton.remove();
        this._map = undefined;
    };

    module.BaseLayerSelectorController.prototype._instantiateBaseLayer = function(name, apiKey, year) {
        var layerConstructor = eval("am.utils." + name[0].toLowerCase() + name.substr(1) + "Layer");
        if (layerConstructor instanceof Function) {
            return layerConstructor(apiKey, year);
        } else {
            throw new Error("Cannot find the function creating a new base layer of type '" + name + "'");
        }
    };

    module.BaseLayerSelectorController.prototype.hideBaseLayerField = function() {
        $(this._controlButton.getContainer()).addClass('hidden');
    };

    module.BaseLayerSelectorController.prototype.showBaseLayerField = function() {
        $(this._controlButton.getContainer()).removeClass('hidden');
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.BaseLayerSelectorController
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Configuration object to be passed to the constructor of class 
     *      am.BaseLayerSelectorController
     * @return {am.BaseLayerSelectorController} - New instance of class am.BaseLayerSelectorController
     */
    module.baseLayerSelectorController = function(mainController, config) {
        var ctrl = new am.BaseLayerSelectorController();
        ctrl.init(mainController, config);
        return ctrl;
    };

    return module;

})(am.utils || {});